import { useState, useReducer, useRef, useEffect } from "react"
import { select } from 'd3-selection'
import { axisBottom, axisLeft } from 'd3-axis'
import { scaleLinear } from 'd3-scale'
import { zoom } from 'd3-zoom'
import { usefetchTranscriptProteins } from '../hooks.js'
import Select from "../widgets/Select.jsx"
import { downloadFile, decoratedlist, horizontalList, HeaderWithModal } from "../utils.jsx"
import TranscriptDrawer from "./TranscriptDrawer.jsx"
import GeneModelDrawer from "./GeneModelDrawer.jsx"

const TranscriptViewer = ({species_sn, protein_seq_id, protDetails}) => {

    const {isReadyTranscripts, data:transcriptProt} = usefetchTranscriptProteins({species_sn, protein_seq_id})
    
    if (!isReadyTranscripts) {
        return <span>Loading</span>
      };
      
      const groupedByTranscript = transcriptProt.reduce((accumulator, item) => {
        const transcriptAccession = item.trans_accession;
        if (!accumulator[transcriptAccession]) {
          accumulator[transcriptAccession] = [];
        }
        accumulator[transcriptAccession].push(item);
        return accumulator;
      }, {});
      
      
    const GeneDrawings = (trxps) => {
        const transcriptList = Object.entries(trxps).map(([transcriptAccession, items]) => {
            return {
                trxp: items,
                protDetails: protDetails,
                accession: transcriptAccession
            };
        });
        const highlightedAccession = protDetails?.[0]?.accession;
        return <GeneModelDrawer transcriptList={transcriptList} highlightedProtein={highlightedAccession} />;
    }

    const TranscriptDrawings = (trxps) => Object.entries(trxps).map((trxp, idx) => 
        {
            return <div><TranscriptDrawer trxp={trxp[1]} protDetails={protDetails} /></div>
        })

    return (
        <>
        
        <div className="shadow-[0px_0px_6px_0px_rgba(0,0,0,0.2)] mt-3 mr-3 rounded p-3">
            <div className="border-b width-full border-slate-200">
                <HeaderWithModal title="Gene model & Transcripts">
                    <p className="font-semibold">
                        Gene model & Transcripts
                    </p>
                </HeaderWithModal>
            {GeneDrawings(groupedByTranscript)}
            </div>
        </div>
        </>
    )
}

export default TranscriptViewer
